// Typelizer digest 6b7cb3f9ce0a012cc34e0786ceac35c9
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../../runtime'
import { buildUrl } from '../../../runtime'

export default {
  /** PATCH /accountant/clients/:client_id/period_start */
  update: (
    params: { clientId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/accountant/clients/:client_id/period_start', params, options),
    method: 'patch',
  }),
}
